<!-- DESKTOP LAYOUT -->
<div class="wrap"
     sizeClass="XL:p-t-20 p-b-20, SM: p-t p-b">

    @if (!fullPage) {
    <ng-container *ifSize="'XL'">
        <!-- heading ro -->
        <div class="h1">{{'Hello' | translate}} {{customer.model.data.firstname}} {{customer.model.data.lastname}}
        </div>
        <!-- line -->
        <line-separator class="block m-t-6 m-b-10"></line-separator>
        <!-- left side nav -->
        <div class="c-3 m-b-0">
            <account-navigation></account-navigation>
        </div>
    </ng-container>
    }

    <!-- main content -->
    <div class="m-b-0 m-r-0 c-12-s c-12-m"
         [ngClass]="'c-' + contentCols">
        <router-outlet></router-outlet>
    </div>
</div>



<!-- bottom components -->
<icms-outlet [components]="content?.bottomComponents"></icms-outlet>
